// extracted by mini-css-extract-plugin
export default {"container":"Icon_container__f2KGZ","clickable":"Icon_clickable__DFj1q"};